import { RequirementAdditionalData } from "../types";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";

export const selectorIsSharedFileRequest = (
  data: RequirementAdditionalData
): data is ISharedFileRequestResponse => {
  return data ? "sharedFileRequestId" in data : false;
};
